module.exports = __webpack_public_path__ + "static/media/html_icon.589cdc35.svg";